var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSheetVersions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.62 45.4299H112.95",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.02 45.4199H123.36V48.7599",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.36 55.8199V108.78",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.06 7.06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M123.36 112.31V115.64H120.02",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M113.1 115.64H47.3",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.93 6.93"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.83 115.64H40.5C39.3835 115.64 38.276 115.44 37.23 115.05",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.85 109.66C31.4499 108.62 31.2465 107.514 31.25 106.4",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.26 60.2999H134.59",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M141.67 60.2999H145V63.6399",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M145 70.7V123.66",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "7.06 7.06"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M145 127.19V130.52H141.67",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M135.05 130.52H72.1699",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.62 6.62"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.86 130.52H65.53C64.4134 130.521 63.3058 130.321 62.26 129.93",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.87 124.54C56.4778 123.494 56.2779 122.387 56.28 121.27",
    stroke: "#E9AF34",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.16 96.06C113.603 96.0259 114.049 96.0796 114.471 96.218C114.894 96.3565 115.285 96.5769 115.622 96.8668C115.96 97.1566 116.236 97.5101 116.437 97.9071C116.637 98.304 116.757 98.7366 116.79 99.18C116.79 100.45 116.22 101.4 114.32 103.36L111.44 106.36H117V107.62H109.49V106.62L113.49 102.4C115.02 100.8 115.38 100.19 115.38 99.24C115.365 98.9606 115.294 98.6869 115.173 98.4348C115.051 98.1828 114.881 97.9573 114.672 97.7713C114.462 97.5854 114.218 97.4427 113.954 97.3515C113.689 97.2603 113.409 97.2224 113.13 97.24C112.828 97.2251 112.526 97.2717 112.243 97.3771C111.959 97.4825 111.7 97.6444 111.481 97.853C111.263 98.0615 111.088 98.3124 110.97 98.5904C110.851 98.8684 110.79 99.1677 110.79 99.47H109.4C109.415 98.9966 109.525 98.5311 109.724 98.1012C109.923 97.6713 110.206 97.2857 110.557 96.9676C110.908 96.6494 111.319 96.4051 111.766 96.2492C112.213 96.0932 112.687 96.0289 113.16 96.06Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.67 112.54L132.67 114.71V113.21L135.67 111.04H137V122.42H135.63L135.67 112.54Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88 85.4799H89.35C89.6274 85.505 89.9069 85.4719 90.1707 85.3826C90.4346 85.2934 90.6769 85.1501 90.8821 84.9618C91.0873 84.7735 91.2509 84.5445 91.3625 84.2893C91.4741 84.0341 91.5311 83.7584 91.53 83.4799C91.53 82.3699 90.78 81.6199 89.36 81.6199C89.0859 81.5953 88.8096 81.6253 88.5471 81.7082C88.2847 81.7911 88.0413 81.9253 87.8311 82.1029C87.6209 82.2806 87.448 82.4982 87.3225 82.7432C87.197 82.9881 87.1214 83.2555 87.1 83.5299H85.77C85.8001 83.0819 85.9196 82.6444 86.1217 82.2433C86.3237 81.8423 86.604 81.4858 86.9462 81.1949C87.2883 80.9041 87.6853 80.6848 88.1136 80.5499C88.5419 80.4151 88.993 80.3675 89.44 80.4099C91.44 80.4099 92.96 81.6099 92.96 83.2899C92.9875 83.9481 92.7661 84.5924 92.3398 85.0946C91.9136 85.5968 91.3138 85.9201 90.66 85.9999C91.024 85.9849 91.3873 86.0444 91.7274 86.175C92.0676 86.3056 92.3774 86.5044 92.6378 86.7592C92.8982 87.014 93.1037 87.3194 93.2417 87.6566C93.3796 87.9938 93.4471 88.3557 93.44 88.7199C93.44 90.6399 91.69 91.9899 89.44 91.9899C87.19 91.9899 85.6 90.6899 85.5 88.8399H86.84C86.9316 89.4361 87.2528 89.9728 87.7349 90.3354C88.217 90.6979 88.8218 90.8574 89.42 90.7799C91 90.8099 92 89.9999 92 88.7999C92 87.5999 91 86.6599 89.41 86.6599H88V85.4799Z",
    fill: "#DB6C2F",
    stroke: "#DB6C2F",
    strokeWidth: 0.17,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1101 87.9899H31.1001V43.6599H43.6801",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M54.78 43.6599H88.47V75.7399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8201 68.5799V41.8199",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1599 63.0499H71.0399",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3201 63.0499H44.0701",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8201 89.8399V79.6699",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8699 30.72H101.41V100.93H15.1699C12.7167 100.93 10.3639 99.9554 8.62918 98.2207C6.89447 96.486 5.91992 94.1332 5.91992 91.68",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5 29.43C5.01348 27.7016 5.47468 26.0063 6.33862 24.5094C7.20257 23.0124 8.43975 21.7649 9.92949 20.8886C11.4192 20.0123 13.1107 19.537 14.8388 19.5092C16.567 19.4814 18.2728 19.902 19.79 20.73V83.91C18.2728 83.082 16.567 82.6614 14.8388 82.6892C13.1107 82.717 11.4192 83.1923 9.92949 84.0686C8.43975 84.9449 7.20257 86.1924 6.33862 87.6894C5.47468 89.1863 5.01348 90.8816 5 92.61V29.43Z",
    fill: "#E9AF34",
    stroke: "#E9AF34",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheetVersions);
export default __webpack_public_path__ + "static/media/sheet_versions.09001bc2d78973d0362634721abb574e.svg";
export { ForwardRef as ReactComponent };